/* Cart cross-sell ("Customers also add") - snippets/cart-cross-sell.liquid */
(function () {
  if (!window.customElements || window.customElements.get('cart-cross-sell')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FALLBACK_ERROR = 'Sorry, we could not add that to your cart.';

  function collectSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  // Same "Total <Unit>" property as the product form (pack size x quantity); cart.js folds a
  // second line for the same variant. Skipped when the key or pack size is unknown.
  function addToCart(variantId, totalKey, packOf) {
    var item = { id: variantId, quantity: 1 };
    var pack = parseFloat(packOf);
    if (totalKey && pack > 0) {
      item.properties = {};
      item.properties[totalKey] = String(Math.round(pack * item.quantity));
    }
    var body = {
      items: [item],
      sections: collectSections(),
      sections_url: window.location.pathname
    };
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || FALLBACK_ERROR);
        }
        return data;
      });
    });
  }

  // Same refresh route the theme's quantity buttons and product form use:
  // publish cartUpdate with the bundled section HTML so <cart-items> re-renders
  // the drawer body/footer (and the /cart page), cart counts update and
  // "cart:updated" fires for the free-shipping bar.
  function refreshCart(addData) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var hasPubsub = window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS;
        if (hasPubsub && addData && addData.sections) {
          cart.sections = addData.sections;
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          return;
        }
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          return;
        }
        window.location.reload();
      });
  }

  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      this.enhanceSelects();
      if (this.ccsBound) return;
      this.ccsBound = true;
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
    }

    // Compact picker: a small visible label over a transparent native <select>
    // whose own text is 16px, so iOS Safari does not zoom the page on focus.
    enhanceSelects() {
      this.querySelectorAll('[data-ccs-select]').forEach(function (select) {
        var parent = select.parentElement;
        if (!parent || parent.classList.contains('ccs__picker')) return;
        var picker = document.createElement('span');
        picker.className = 'ccs__picker';
        var label = document.createElement('span');
        label.className = 'ccs__picker-label';
        label.setAttribute('aria-hidden', 'true');
        label.setAttribute('data-ccs-label', '');
        var option = select.options[select.selectedIndex];
        label.textContent = option ? option.text : '';
        parent.insertBefore(picker, select);
        picker.appendChild(label);
        picker.appendChild(select);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.ccsBound = false;
    }

    showError(message) {
      var errorEl = this.querySelector('[data-ccs-error]');
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    setLoading(button, isLoading) {
      button.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
      }
    }

    onChange = (event) => {
      var select = event.target;
      if (!select || !select.matches('[data-ccs-select]')) return;
      var row = select.closest('[data-ccs-row]');
      var option = select.options[select.selectedIndex];
      if (!row || !option) return;
      var button = row.querySelector('[data-ccs-add]');
      var price = row.querySelector('[data-ccs-price]');
      var image = row.querySelector('[data-ccs-img]');
      if (button) {
        button.value = option.value;
        button.dataset.packOf = option.dataset.packOf || '';
      }
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (image && option.dataset.image) image.src = option.dataset.image;
      var label = row.querySelector('[data-ccs-label]');
      if (label) label.textContent = option.text;
    };

    onClick = (event) => {
      var more = event.target.closest('[data-ccs-more]');
      if (more && this.contains(more)) {
        var expanded = more.getAttribute('aria-expanded') === 'true';
        this.classList.toggle('is-expanded', !expanded);
        more.setAttribute('aria-expanded', String(!expanded));
        more.textContent = expanded ? more.dataset.labelMore : more.dataset.labelLess;
        return;
      }

      var button = event.target.closest('[data-ccs-add]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true') return;
      var variantId = Number(button.value);
      if (!variantId) return;

      var self = this;
      this.showError('');
      this.setLoading(button, true);
      var row = button.closest('[data-ccs-row]');
      addToCart(variantId, row && row.dataset.totalKey, button.dataset.packOf)
        .then(function (data) {
          // The item is in the cart at this point; if the refresh fails, reload.
          return refreshCart(data).catch(function () {
            window.location.reload();
          });
        })
        .then(function () {
          // The drawer/cart re-render normally replaces this element; reset if it did not.
          if (button.isConnected) self.setLoading(button, false);
        })
        .catch(function (error) {
          self.setLoading(button, false);
          self.showError((error && error.message) || FALLBACK_ERROR);
        });
    };
  }

  customElements.define('cart-cross-sell', CartCrossSell);
})();
